export default __webpack_public_path__ + "static/media/cellsolar-01.0b897da2.png";